export default __webpack_public_path__ + "static/media/headgear-incorrect1.f6d759f2.PNG";